// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_XTd","cls2":"ReportList-cls2_LYB ReportList-cls1_XTd"};